/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/KlondikeLogic/ChallengeAuthorities/PlayValuesKlondikeAuthority',[
    'SolitaireShared/KlondikeLogic/IDailyKlondikeAuthority',
    'SolitaireShared/CardLogic/IPlayValuesDailyAuthority',
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/CardOp',
    'SolitaireShared/CardLogic/CardValue'

], function (IDailyKlondikeAuthority, IPlayValuesDailyAuthority, IDailyAuthority, CardOp, CardValue) {
    "use strict";

    var PlayValuesDailyKlondikeAuthority = function (param) {
        this.initPlayValuesDailyKlondikeAuthority(param);
    };

    PlayValuesDailyKlondikeAuthority.KeyNumToPlay = "NUMTOPLAY";
    PlayValuesDailyKlondikeAuthority.KeyValueToPlay = "VALUETOPLAY";
    var TagValuePlayed = 0x10000;
    var TagValueRemoved = 0x11111;


    PlayValuesDailyKlondikeAuthority.constructor = PlayValuesDailyKlondikeAuthority;
    PlayValuesDailyKlondikeAuthority.prototype = Object.create(IDailyKlondikeAuthority.prototype);
    IPlayValuesDailyAuthority.call(PlayValuesDailyKlondikeAuthority.prototype);


    PlayValuesDailyKlondikeAuthority.prototype.initPlayValuesDailyKlondikeAuthority = function (param) {
        IDailyKlondikeAuthority.call(this, param);
        this._hasWon = false;
        this.numPlayed = 0;

        var isDirty = true;
        if (param != null && param[PlayValuesDailyKlondikeAuthority.KeyNumToPlay] && param[PlayValuesDailyKlondikeAuthority.KeyValueToPlay])
        {
            isDirty = false;

            this.NumToPlay = parseInt(param[PlayValuesDailyKlondikeAuthority.KeyNumToPlay]);
            this.ValueToPlay = CardValue.getValue(param[PlayValuesDailyKlondikeAuthority.KeyValueToPlay]);

            if (isNaN(this.NumToPlay) || !this.ValueToPlay) {
                isDirty = true;
            }

            if (isDirty)
                throw "Invalid parameter passed in creating Daily Challenge";
        }

    };

    Object.defineProperty(PlayValuesDailyKlondikeAuthority.prototype, "ChallengeType", {
        get: function () {
            return IDailyAuthority.ChallengeType.PlayValues;
        }
    });

    Object.defineProperty(PlayValuesDailyKlondikeAuthority.prototype, "Value", {
        get: function () {
            return this.ValueToPlay;
        }
    });

    Object.defineProperty(PlayValuesDailyKlondikeAuthority.prototype, "NumberToPlay", {
        get: function () {
            return this.NumToPlay;
        }
    });

    Object.defineProperty(PlayValuesDailyKlondikeAuthority.prototype, "NumberPlayed", {
        get: function () {
            var numPlayed = 0;
            for (var i = 0; i < 4; i++)
            {
                var pile = this.CardSupply.GetPile("Foundation" + i);
                if (!pile.Empty && pile.Top.Value >= this.ValueToPlay)
                {
                    numPlayed++;
                }
            }
            return numPlayed;
        }
    });


    PlayValuesDailyKlondikeAuthority.prototype.Reset = function ()
    {
        this._numPlayed = 0;

        IDailyKlondikeAuthority.prototype.Reset.call(this);
    };

    PlayValuesDailyKlondikeAuthority.prototype.GetScoreForAction = function (action)
    {
        //foreach (CardOp op in action.Ops)
        for (var i = 0; i < action.Ops; i ++)
        {
            var op = action.Ops[i];

            var destPile = op.GetPile(CardOp.eMoveParams.DestPile);
            var sourcePile = op.GetPile(CardOp.eMoveParams.SourcePile);
            if (op.Opcode == CardOp.Op.Move
                && destPile.Type == "Foundation"
                && destPile.NthFromTop(op.GetNumber(CardOp.eMoveParams.NumCards)).Value == this.ValueToPlay)
            {
                action.Tag = (action.Tag | TagValuePlayed) >>> 0;
                break;
            }
            if (op.Opcode == CardOp.Op.Move
                && destPile.Type == "Tableau"
                && sourcePile.Type == "Foundation"
                && destPile.NthFromTop(op.GetNumber(CardOp.eMoveParams.NumCards)).Value == this.ValueToPlay)
            {
                action.Tag = TagValueRemoved; // TODO is this a bug? Should |?
                break;
            }
        }

        return IDailyKlondikeAuthority.prototype.GetScoreForAction.call(this, action);
    };

    PlayValuesDailyKlondikeAuthority.prototype.OnRunSpecialAction = function (tag, undo)
    {
        if ((tag == TagValuePlayed))
        {
            this._numPlayed += (undo ? -1 : 1);
        }
        if ((tag == TagValueRemoved))
        {
            this._numPlayed -= (undo ? -1 : 1);
        }
        IDailyKlondikeAuthority.prototype.OnRunSpecialAction.call(this, tag, undo);
    };

    PlayValuesDailyKlondikeAuthority.prototype.IsGameWon = function ()
    {
        /*if (CheckWin() && !CardSupply.WaitingForAnimation && NumberPlayed < _numToPlay)
         Deal();*/
        return this.GetIsGameWon() && !this.CardSupply.WaitingForAnimation;
    };

    PlayValuesDailyKlondikeAuthority.prototype.GetIsGameWon = function ()
    {
        return this.NumberPlayed >= this.NumToPlay;
    };

    PlayValuesDailyKlondikeAuthority.prototype.GetHint = function (cycle, cheat)
    {
        if(cheat) {
            return IDailyKlondikeAuthority.prototype.GetHint.call(this,cycle,cheat);
        }

        cycle = !!cycle;
        var numTableaus = 7;

        var hints = [];

        var a;
        this.CardSupply.GetPile("Foundation");
        var cards = ["CHALLENGE"];

        for (var i = numTableaus - 1; i >= 0; i--)
        {
            a = this.CardSupply.GetPile("Tableau" + i);
            if (a.Empty)
                continue;

            var pileCards = a.GetCards();
            for (var ci = 0; ci < pileCards.length; ci++)
            {
                var c = pileCards[ci];
                if (c.Value == this.ValueToPlay)
                {
                    cards.push(c.Sequence.toString());
                }
            }
        }

        a = this.CardSupply.GetPile("Waste");
        if (!a.Empty)
        {
            var c = a.Top;
            if (c.Value == this.ValueToPlay)
            {
                cards.push(c.Sequence.toString());
            }
        }

        if (cards.length > 1)
        {
            var hint = new CardOp(this.CardSupply);

            hint.Parse(cards, 0);
            hints.push(hint);
        }

        return hints.length > 0 ? hints[0] : new CardOp(this.CardSupply);
    };

    return PlayValuesDailyKlondikeAuthority;

});
